import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { HeaderServiceProxy } from '@telecom/shared/services/header-service/header-service-proxy';
import { isUserLogin } from '@telecom/shared/startup/user-auth';
import { OnboardingBrowserRuntimeImpl } from '../../common/services/impls/onboarding-browser-runtime';
import type { NoveltySearchOnboardingRuntime } from '../novelty-search-onboarding-runtime';

/**
 * 查新首页首次引导的浏览器运行时。
 *
 * 统一封装身份、登录态、存储、Driver、DOM 查询和定时器能力，
 * 避免业务 service 直接依赖具体浏览器 API。
 */
@injectable()
export class NoveltySearchOnboardingRuntimeImpl
    extends OnboardingBrowserRuntimeImpl
    implements NoveltySearchOnboardingRuntime {
    constructor(
        /** 提供当前登录账号信息。 */
        @inject(HeaderServiceProxy)
        private readonly _headerServiceProxy: HeaderServiceProxy,
    ) {
        super();
    }

    /** 获取用于隔离首次展示状态的登录账号 ID。 */
    getIdentityId(): Promise<string> {
        return Promise.resolve(
            this._headerServiceProxy.headerService.account?._info.account_id ?? '',
        );
    }

    /** 查询当前用户登录状态。 */
    isUserLogin(): Promise<boolean> {
        return isUserLogin();
    }
}
